import { Button } from "@mui/material"
import { PushPin, Check } from "@mui/icons-material"
import { usePinArtifact, type AiTeammateArtifact } from "../../hooks/use-pin-artifact"
import type { ArtifactKind } from "connected-components/dashboard/modules/ai-artifact/types"

/**
 * Props for PinArtifactButton component
 */
interface PinArtifactButtonProps {
  artifact: AiTeammateArtifact
  kind: ArtifactKind
}

/**
 * Button component for pinning AI artifacts to the dashboard
 *
 * Uses Event Emitter pattern to communicate with Dashboard instead of Context.
 * This ensures AI Teammate components remain decoupled from Dashboard implementation.
 */
export default function PinArtifactButton({ artifact, kind }: PinArtifactButtonProps) {
  const { pin, isPinning, isPinned } = usePinArtifact({ artifact, kind, title: artifact.title })

  let buttonText = "Pin to Dashboard"
  if (isPinned) {
    buttonText = "Pinned!"
  } else if (isPinning) {
    buttonText = "Pinning..."
  }

  return (
    <Button
      size="small"
      variant="outlined"
      color="primary"
      startIcon={isPinned ? <Check /> : <PushPin />}
      onClick={pin}
      disabled={isPinning || isPinned}
    >
      {buttonText}
    </Button>
  )
}
